var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.featuredProducts.products
    ? _c("div", { staticClass: "featured-collection" }, [
        _c("div", { staticClass: "featured-collection__header" }, [
          _vm.sectionTitle
            ? _c("h3", { staticClass: "featured-collection__title" }, [
                _vm._v(_vm._s(_vm.sectionTitle))
              ])
            : _vm._e(),
          _c("div", { staticClass: "featured-collection__pagination" }, [
            _c(
              "div",
              {
                staticClass:
                  "featured-collection__pagination-arrow featured-collection__pagination-arrow--left"
              },
              [
                _c("icon", { attrs: { name: "long-arrow-left", size: "32px" } })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "featured-collection__pagination-arrow featured-collection__pagination-arrow--right"
              },
              [
                _c("icon", {
                  attrs: { name: "long-arrow-right", size: "32px" }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "featured-collection__sliders" },
          [
            _c(
              "swiper",
              {
                ref: "featuredCollection",
                attrs: { options: _vm.swiperOptions }
              },
              _vm._l(_vm.featuredProducts.products, function(product, index) {
                return _c(
                  "swiper-slide",
                  { key: index },
                  [_c("product-tile", { attrs: { product: product } })],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }